import R from 'ramda'
import {
  mapTwitterFormActionsToWidgetActions,
  mapTwitterWidgetActionsToFormActions
} from './twitter'
import {
  mapInstagramFormActionsToWidgetActions,
  mapInstagramWidgetActionsToFormActions
} from './instagram'
import {
  mapFacebookFormActionsToWidgetActions,
  mapFacebookWidgetActionsToFormActions
} from './facebook'

const PLATFORM_TWITTER = 'TWITTER'
const PLATFORM_INSTAGRAM = 'INSTAGRAM'
const PLATFORM_FACEBOOK = 'FACEBOOK'

const getPlatform = R.pipe(R.propOr(PLATFORM_TWITTER, 'platform'), R.toUpper)

const isTwitter = R.pipe(getPlatform, R.equals(PLATFORM_TWITTER))
const isInstagram = R.pipe(getPlatform, R.equals(PLATFORM_INSTAGRAM))
const isFacebook = R.pipe(getPlatform, R.equals(PLATFORM_FACEBOOK))

const getSuccessActions = R.propOr([], 'success')

const mapSuccessFormActionsToWidgetActions = R.cond([
  [isTwitter, R.pipe(getSuccessActions, mapTwitterFormActionsToWidgetActions)],
  [
    isInstagram,
    R.pipe(getSuccessActions, mapInstagramFormActionsToWidgetActions)
  ],
  [isFacebook, R.pipe(getSuccessActions, mapFacebookFormActionsToWidgetActions)]
])

const mapSuccessWidgetActionsToFormActions = R.cond([
  [isTwitter, R.pipe(getSuccessActions, mapTwitterWidgetActionsToFormActions)],
  [
    isInstagram,
    R.pipe(getSuccessActions, mapInstagramWidgetActionsToFormActions)
  ],
  [isFacebook, R.pipe(getSuccessActions, mapFacebookWidgetActionsToFormActions)]
])

export {
  mapSuccessFormActionsToWidgetActions,
  mapSuccessWidgetActionsToFormActions
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/index.js